<div
  [ngClass]="{
    chatbox: true,
    open: true,
    'expand-window': !isRestore,
    'minimize-window': minimizeChatPanel
  }"
>
  <!-- ChatBot Header section starts here -->
  <div class="header">
    <div class="chatbox-img-title-wrapper">
      <img [src]="imgPath" class="vizibl-v-logo" />
      <span class="chat-box-title ms-2">Support assistant</span>
    </div>
    <div>
      <mat-icon
        class="cursor_pointer minimize_icon me-3"
        (click)="updateMinimizeState()"
        >minimize</mat-icon
      >
      <i
        *ngIf="!isRestore"
        class="far fa-square me-3 icon-topo cursor_pointer"
        (click)="isRestore = true"
      ></i>
      <i
        *ngIf="isRestore"
        class="far fa-window-restore me-3 icon-topo cursor_pointer"
        (click)="isRestore = false"
      ></i>
      <mat-icon class="close-icon cursor_pointer" (click)="close()"
        >cancel</mat-icon
      >
    </div>
  </div>
  <!-- ChatBot Header section ends here -->

  <!-- ChatBot Conversation section starts here -->
  <app-conversation
    class="chatbox-conversation"
    [messages]="messages"
    [isTyping]="isTyping"
    [isShowPrompt]="isShowPrompt"
    (promptState)="showPrompt()"
    (navigateTo)="goToQuery($event)"
  ></app-conversation>
  <!-- ChatBot Conversation section ends here -->

  <!-- ChatBot Prompt section starts here -->
  <div *ngIf="isShowPrompt" class="chat-bot-footer">
    <app-prompt
      [isTyping]="isTyping"
      (textChange)="handleUserQuery(false, $event)"
    ></app-prompt>
  </div>
  <!-- ChatBot Prompt section ends here -->
</div>
